// src/config.ts

// Default base URL if environment variable is not set (should match your development/fallback)
const DEFAULT_BACKEND_URL = 'http://localhost:3000';//https://myhome.cfc.io/api';
const DEFAULT_API_BASE_URL = DEFAULT_BACKEND_URL + '/unitai';
const DEFAULT_BETA_REQUEST_URL = DEFAULT_BACKEND_URL + '/beta/request-access';

// Frontend URL for redirects
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173';

// API Base URL - Sourced from Vite environment variables
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;

// Email Auth Base URL - Derived from API_BASE_URL
export const EMAIL_AUTH_URL = `${API_BASE_URL}/auth/email`;

// Beta Request URL - Sourced from Vite environment variables
export const BETA_REQUEST_URL = import.meta.env.VITE_BETA_REQUEST_URL || DEFAULT_BETA_REQUEST_URL;

// Specific Endpoint for Google OAuth Callback
export const BACKEND_AUTH_URL = `${API_BASE_URL}/auth/google/callback`;

// Stripe Publishable Keys - Sourced from Vite environment variables or fallback to hardcoded (for local dev)
// IMPORTANT: Ensure your .env files are correctly set for different environments (development, production)
const DEFAULT_SANDBOX_STRIPE_KEY = 'pk_test_51RTKDWRc1phGdeqe5yQC2DQWTnyodk832at3UkJBGhKsY155p2sTlc9r1HllzCps36OvWjQIqhkb3QPu4UAggJH700YsUJ08QS';
const DEFAULT_LIVE_STRIPE_KEY = 'pk_live_kJHSZ5C7ZwxLgAIRJKoWcFLU'; // Replace with your actual live key if needed for fallback

export const SANDBOX_STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_SANDBOX || DEFAULT_SANDBOX_STRIPE_KEY;
export const LIVE_STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_LIVE || DEFAULT_LIVE_STRIPE_KEY;

// Determine which Stripe key to use based on Vite's mode or a custom VITE_ENV_MODE
export const IS_PRODUCTION_LIKE_ENV = import.meta.env.MODE === 'production' || import.meta.env.VITE_ENV_MODE === 'production';
export const STRIPE_PUBLISHABLE_KEY = IS_PRODUCTION_LIKE_ENV
                                    ? LIVE_STRIPE_PUBLISHABLE_KEY
                                    : SANDBOX_STRIPE_PUBLISHABLE_KEY;

// Cookie Names
export const REFERRAL_COOKIE_NAME = 'unitai_ref_code';

// Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-4QEK77GCSR';

// You can add other shared constants here, e.g., default pagination limits, etc.
export const DEFAULT_PAGINATION_LIMIT = 10; 